import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sousuo",
  "use": "icon-sousuo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sousuo\"><path d=\"M785.493333 740.266667l-45.226666 45.226666 139.306666 139.36a32 32 0 0 0 45.28 0 32 32 0 0 0 0-45.28l-139.36-139.306666z\" fill=\"#ffffff\" /><path d=\"M495.093333 153.76a341.333333 341.333333 0 1 1-241.333333 100 339.093333 339.093333 0 0 1 241.333333-100m0-64a405.333333 405.333333 0 1 0 286.613334 118.72 404.053333 404.053333 0 0 0-286.613334-118.72z\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol